import Enum from "./Enum";

export default Enum.create( {
	UP: "UP",
	DOWN: "DOWN",
	NONE: "NONE",
} );
